import {createI18n} from "vue-i18n";

const i18n = createI18n({
    locale: 'en',
    messages: {},
    silentTranslationWarn: true,
})

import {getTranslationsApi} from "@/api/translations";
import {mainStore} from "@/store/main";


export async function loadTranslations(locale) {
    if (!locale) return
    if (mainStore().translations[locale]) {
        i18n.global.locale = locale
    } else {
        getTranslationsApi(locale).then((resp) => {
            i18n.global.setLocaleMessage(locale, resp.data.items)
            mainStore().setTranslation(locale, resp.data.items)
            mainStore().setGlobalLoading(false)
        }, (error) => {
            mainStore().setGlobalLoading(false)
        })
    }
    if (i18n.global.locale !== locale) {
        i18n.global.locale = locale
    }
}


export default i18n
